import React, { useState, useRef } from "react"
import { Formik, Field, Form, ErrorMessage } from "formik"
import * as Yup from "yup"
import axios from "axios"
import { navigate } from "gatsby"

import { SavorReasonLists } from "./savorReasonLists"
import Logo from "../BrandLogo"
import { PopupContent } from "./Popup/content"
import { Popup } from "./Popup"

import { useContent } from "../../context/contentProvider"

import "./index.css"
import ContentfulLongText from "../ContentfulLongText"

const ContactForm = ({ pageName="", contactForm, colorValue, languageVal='English' }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [emailVal, setEmailVal] = useState('')

    const { setFormPopup, setFormPopupContent } = useContent()
    const emailInputRef = useRef(null);

    const handleNoClick = () => {
        if (emailInputRef.current) {
            emailInputRef.current.focus();
        }
    };

    const isWhite = colorValue === 'rgb(229, 62, 62)' ? 'text-white': 'text--dark'

    return (
        <div className="block" style={{ backgroundColor: colorValue }}>
            <div className="component-form">
                <h3 className={`mt-0 pt-16 mb-10 uppercase text-center ${isWhite}`}><img src={'https://images.ctfassets.net/vhts96p7twn6/6zs5NNwwZdvltZCMbeB6Zi/6267679e0c853b966b36b9f40958db99/SB_Star_burst-02.png'} className="mb-0 w-h-32 vertical-text-top mr-5" alt="Savor Brands" />{contactForm && contactForm.title ? contactForm.title : 'Contact Our Team!'}</h3>
                <div className="grid col-4-8 col-1-md form-wrap">
                    <div className="left-wrap">
                        <div className="left-wrap--content">
                            <Logo href="/" title="Savor Brands Logo" isDarkMode={false} className="mr-0" />
                            <p className="mt-10 mb-0 text-white">{contactForm && contactForm.description ? <ContentfulLongText longTextContent={contactForm.description.description}/> : 'Please feel free to reach out our Team!'}</p>
                            <a href="tel:8085998988" className="mt-10 text-white decoration-none link--number">(808)599-8988</a>
                        </div>
                        <SavorReasonLists listTitle={contactForm && contactForm.listTitle ? contactForm.listTitle:null} lists={contactForm && contactForm.lists ? contactForm.lists:null} languageVal={languageVal} />
                    </div>
                    <div className="right-wrap">
                        <Formik
                        initialValues={{ name: '', company: '', email: '', phone: '', message: '', location: '' }}
                        validationSchema={Yup.object({
                            name: Yup.string().required('Required'),
                            company: Yup.string().required('Required'),
                            email: Yup.string().email('Invalid email address').required('Required'),
                            phone: Yup.string().required("Required"),
                            message: Yup.string().required('Required'),
                            location: Yup.string().required('Required')
                        })}
                        onSubmit={async (values, { resetForm, setSubmitting }) => {
                            try {
                                setFormPopup(false)
                                setIsLoading(true);
                                const requestData = {
                                    name: values.name,
                                    company: values.company,
                                    phone: values.phone,
                                    message: values.message,
                                    email: values.email,
                                    location: values.location,
                                    landingPageName: pageName
                                }
                                await axios.post("https://g5wf04qzb1.execute-api.us-west-2.amazonaws.com/production/sendemail", requestData);
                                navigate('/thank-you/');
                                resetForm();
                                setIsLoading(false);
                            } catch (error) {
                                alert("Form submission failed. Please try again.");
                            }
                        }}
                        >
                            {({setFieldValue, values}) => (
                                <Form>
                                    <div className="grid col-2 col-1-md gap-10">
                                        <div className="form-field">
                                            <Field name="name" type="text" placeholder={contactForm && contactForm.name ? contactForm.name : "Name"} />
                                            <ErrorMessage className="form-field--err" name="name" component="div" />
                                        </div>
                                        <div className="form-field">
                                            <Field type="tel" id="phone" name="phone" placeholder={contactForm && contactForm.phone ? contactForm.phone : "Phone"} />
                                            <ErrorMessage className="form-field--err" name="phone" component="div" />
                                        </div>
                                    </div>
                                    <div className="grid col-2 col-1-md gap-10">
                                        <div className="form-field">
                                            <Field name="email" type="email" placeholder={contactForm && contactForm.email ? contactForm.email : "Email"} />
                                            <ErrorMessage className="form-field--err" name="email" component="div" />
                                        </div>
                                        <div className="form-field">
                                            <Field name="company" type="text" placeholder={contactForm && contactForm.company ? contactForm.company : "Company"} />
                                            <ErrorMessage className="form-field--err" name="company" component="div" />
                                        </div>
                                    </div>
                                    <div className="form-field">
                                        <Field name="location" type="text" placeholder={contactForm && contactForm.location ? contactForm.location : "Location"} />
                                        <ErrorMessage className="form-field--err" name="location" component="div" />
                                    </div>
                                    <div className="form-field">
                                        <Field name="message" as="textarea" placeholder={contactForm && contactForm.whatAreYouInterestedIn ? contactForm.whatAreYouInterestedIn :"What are you interested in?"} />
                                        <ErrorMessage className="form-field--err" name="message" component="div" />
                                    </div>
                                    <div className="flex justify-center action">
                                        <button type="submit" className={`btn-brand-color-linear bold${isLoading ? ' btn--disabled':''}`}>Submit</button>
                                    </div>
                                    {/* <Popup/> */}
                                </Form>
                            )}
                        </Formik>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ContactForm